export const printError = (err: unknown): string =>
	typeof err === 'string' ? err : 'Something went wrong'
